import React from "react";
import TicketReport from "../modules/TicketReport";

export default function TicketReportPage() {
    return <TicketReport/>
}